// @flow
import React from 'react';

import { Td, Tr, getPropsHeader } from 'app/common/ui-components/table';

import { idsPreschool, props } from './columns';
import type { RowItem } from './useOrgsListTableItems';
import OrgsListTableCellLinks from './OrgsListTableCellLinks';
import OrgsListTableCellSettings from './OrgsListTableCellSettings';


type Props = {
  disabled: boolean
} & RowItem

const OrgsListTableRowPreschool = ({ disabled, ...item }: Props) => {
  const {
    title,
    links,
    settings,
    id,
    locked,
  } = item;
  const headers = getPropsHeader();
  const content = [
    title,
    <OrgsListTableCellLinks orgId={id} items={links} preschool />,
    <OrgsListTableCellSettings orgId={id} link={settings} />,
  ];

  return (
    <Tr
      disabled={disabled || locked}
      interlineBorder
      alignTop
    >
      {idsPreschool.map((columnId, i) => (
        <Td
          key={columnId}
          {...headers(columnId)}
          {...props[columnId]}
        >
          {content[i]}
        </Td>
      ))}
    </Tr>
  );
};

export default OrgsListTableRowPreschool;
